import { Component, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../Services/auth.service';
import { CMSService } from '../Services/cms.service';

@Component({
    selector: 'app-nav-bar-main-login',
    templateUrl: './nav-bar-main-login.component.html',
    styleUrls: ['./nav-bar-main-login.component.css'],
    imports: [RouterLink]
})
/** NavBarMainLogin component*/
export class NavBarMainLoginComponent {

  logo: string = "";
  constructor(private authservice: AuthService, private router: Router, public cmsService: CMSService) {


  }
  ngOnInit() {
    try {

      this.cmsService.getAllLoginPageData().subscribe((data) => {
        
        this.logo = data.logo[0].logo;
       
      });
    } catch (e) { }


    }
    //    window.addEventListener('scroll', function () {
    //  let header = document.querySelector('header');
    //  header.classList.toggle('sticky', window.scrollY > 0);
    //});
  
}
